enum HouseStatus {
    AVAILABLE = 'Available',
    BOOKED = 'Booked',
    UNAVAILABLE = 'Unavailable',
}

export default HouseStatus;
